/**
 * Vite-lib-entry (AB-WP2.1): buildautuu yhdeksi minifioiduksi, source-
 * mapatuksi IIFE-bundleksi (app-runtime.js), jonka AppRenderer-shell lataa
 * <script src>-tagilla serving-endpointin assettipolusta. EI JS:ää
 * Java-stringeissä.
 */

import { boot } from './runtime';
import { attachThemeSync } from './theme';

function start(): void {
  const runtime = boot(document);
  // Portaalin teeman seuranta (WP-ABT5). No-op standalone-sivulla ja silloin
  // kun Appin moodi on kiinnitetty vaaleaan tai tummaan.
  attachThemeSync();
  window.fasthub = window.fasthub || {};
  (window.fasthub as Record<string, unknown>).runtime = runtime;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
